import { NgModule } from '@angular/core'
import { DispenserShipmentDetailModule } from './dispenser-shipment-detail/dispenser-shipment-detail.module'
import { DispenserShipmentHistoryModule } from './dispenser-shipment-history/dispenser-shipment-history.module'

@NgModule({
  imports: [DispenserShipmentHistoryModule, DispenserShipmentDetailModule]
})
export class DispenserShipmentModule {}
